export default "__VITE_ASSET__GXISvWBj__"